// extracted by mini-css-extract-plugin
module.exports = {"left_pane_layout":"LeftPane_left_pane_layout__gjHJO","compact_layout":"LeftPane_compact_layout__eHvk7"};